import { MarketplaceEmailSender } from '@spike/email-marketing-model';

/**
 * True when the marketplace has a fully configured + verified custom sender
 * — the only state that permits sending a campaign under the mandatory-
 * sender rule. Any of `{no sender, disabled, pending, failed, empty email}`
 * returns false.
 *
 * Single source of truth used by:
 *   - `SendConfirmationModal.senderBlocking`
 *   - `ReviewAndSendStep` alert visibility
 *   - `CampaignReviewSummary` From-line rendering
 *
 * Consolidating this predicate here avoids drift if a new sender state is
 * added later — each consumer would otherwise have its own subtly different
 * boolean expression.
 */
export const isSenderReadyForSend = (sender: MarketplaceEmailSender | null): boolean =>
    Boolean(sender?.enabled) && sender?.status === 'verified' && Boolean(sender?.senderEmail);
